import { useSignal } from "@preact/signals-react";
import { FotClient } from "imagica-corekit/dist/base/api/FotClient";
import { getIt } from "../../../../../../uikit/getIt";
import { get, isEmpty } from "lodash";
import { FotAuthStore } from "imagica-corekit/dist/base/store/FotAuthStore";
import { ProjectStore } from "imagica-corekit/dist/base/store/ProjectStore";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import { FotClientAdapter } from "imagica-corekit/dist/base/api/FotClientAdapter";
import { GooglePlaceDetailPhotosType } from "imagica-corekit/dist/base/api/mapTyped/GooglePlaceDetail";

export class IndexBloc {
  src = useSignal("");
  photoList = useSignal<Array<string>>([]);
  brainClient = getIt(FotClient);
  authStore = getIt(FotAuthStore);
  projectStore = getIt(ProjectStore);

  async getUrl(reference: string) {
    const url = `${settings.API}/be/svc-adapter/google/maps/photos?photo_reference=${reference}&maxwidth=400`;

    const restClientAdapter = new FotClientAdapter(settings.API, this.authStore, this.projectStore);
    const response = await fetch(url, {
      headers: restClientAdapter.headers,
    });
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  }

  async initImg(placeid: string) {
    const res = await this.brainClient.map.getPlaceDetail(placeid);
    if (isEmpty(res.photos)) {
      return;
    }
    this.photoList.value = res.photos.map(() => "pending");
    res.photos.forEach(async (x: GooglePlaceDetailPhotosType, index: number) => {
      const url = await this.getUrl(x.photo_reference || "");
      this.photoList.value[index] = url;
    });
  }
}
